<template>
	<fragment>
		<national-hero></national-hero>

		<section class="cards card--list section bg-gray" v-if="listing.length > 0">
			<div class="global-container">
				<event-item v-for="(item, index) in listing" v-bind:item="item" v-bind:key="item.DetailID"></event-item>
			</div>
		</section>

		<section class="section bg-gray align-center" v-else>
			<div class="global-container">
				<h2 class="not-found-heading">Sorry, no items were found matching your specifications.</h2>
				<p>
					Try removing some filters or searching a different term.
				</p>
			</div>
		</section>

		<section class="section bg-gray" v-if="listing.length > 0">
			<div class="global-container">
				<pagination></pagination>
			</div>
		</section>
	</fragment>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex';
	import Pagination from '../components/listing/pagination-dropdown';
	import EventItem from '../components/event/event-item';
	import NationalHero from '../components/event/national-hero';

	export default {
		props: ['result'],
		computed: mapState({
			loading: state => state.listing.loading,
			listing: state => state.listing.listing,
			pagination: state => state.listing.pagination,
		}),
		components: {
			pagination: Pagination,
			'event-item': EventItem,
			'national-hero': NationalHero,
		},
		mounted: function () {
			let _this = this;

			// take props and send to vuex store
			this.setInitData(this.result);

			this.$store.subscribeAction((action, state) => {
				if (action.type === 'listing/setFilter') {
					$('html, body').animate({
						scrollTop: $('.filter-app').offset().top
					}, 1000);
				}
			});

			this.$store.subscribeAction((action, state) => {
				if (action.type === 'listing/setEventFilter') {
					$('html, body').animate({
						scrollTop: $('.filter-app').offset().top
					}, 1000);
				}
			});

			// if each spec change should trigger a new api call, use this. else manually call setFilter action on button click
			this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'listing/updateSpecification') {
					this.setEventFilter();
				}
			});
		},
		methods: {
			...mapActions('listing', { setEventFilter: 'setEventFilter' }),
			...mapMutations('listing', { setInitData: 'setInitData' }),
        },
    }
</script>